import React, { Component } from "react";
import "./Questions.css";
import Answers from "./Answers";

export default class Questions extends Component {
  state = {
    answersNodes: {}
  };

  onQuestionAnswered = async (id, answerNode) => {
    let newAnswersNodes = this.state.answersNodes;
    newAnswersNodes[id] = answerNode;
    await this.setState({
      answersNodes: newAnswersNodes
    });

    let concatNodes = "";
    for (const [key,value] of Object.entries(newAnswersNodes)) {
      concatNodes += value + " ";
    }
    this.props.onQuestionAnswered(this.props.conceptId, concatNodes);
  };

  render() {
    const { questions, conceptId } = this.props;
    return (
      <div className="questions-container">
        {questions.map(question => (
          <>
            <div key={question} className="q-title">
              {question.attributes.number}.-{question.attributes.description}
            </div>
            <Answers
              onQuestionAnswered={this.onQuestionAnswered}
              answers={question.children}
              conceptId={conceptId}
              question={question.attributes}
            />
          </>
        ))}
      </div>
    );
  }
}
